import { useState } from 'react'
import { FaEnvelope, FaLock, FaEye, FaEyeSlash, FaSignInAlt, FaKey } from 'react-icons/fa'
import { supabase } from '../supabaseClient'

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [errorMsg, setErrorMsg] = useState('')
  const [successMsg, setSuccessMsg] = useState('')
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [isForgotPassword, setIsForgotPassword] = useState(false)

  const handleLogin = async (e) => {
    e.preventDefault()
    setErrorMsg('')
    setSuccessMsg('')
    setLoading(true)

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password
    })

    setLoading(false)

    if (error) {
      setErrorMsg(error.message)
    } else {
      onLogin(data.session)
    }
  }

  const handleForgotPassword = async (e) => {
    e.preventDefault()
    setErrorMsg('')
    setSuccessMsg('')
    setLoading(true)

    // Usar la URL de producción para el reset de contraseña
    const resetUrl = window.location.hostname === 'localhost' 
      ? `${window.location.origin}/reset-password`
      : 'https://lubricentros-app.netlify.app/reset-password'

    console.log('📧 Enviando email de reset a:', email)
    console.log('🔗 URL de reset:', resetUrl)

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: resetUrl
    })

    setLoading(false)

    if (error) {
      console.error('❌ Error al enviar email de reset:', error)
      setErrorMsg(error.message)
    } else {
      console.log('✅ Email de reset enviado exitosamente')
      setSuccessMsg('Se ha enviado un email con instrucciones para restablecer tu contraseña.')
    }
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const toggleForgotPassword = () => {
    setIsForgotPassword(!isForgotPassword)
    setErrorMsg('')
    setSuccessMsg('')
  }

  return (
    <form className="login-form" onSubmit={isForgotPassword ? handleForgotPassword : handleLogin}>
      {/* Email */}
      <div className="form-field">
        <label>Correo electrónico</label>
        <div className="input-wrapper">
          <FaEnvelope className="input-icon" />
          <input
            type="email"
            placeholder="ejemplo@lubricentros.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            disabled={loading}
          />
        </div>
      </div>
      
      {/* Password - solo mostrar si no es forgot password */}
      {!isForgotPassword && (
        <div className="form-field">
          <label>Contraseña</label>
          <div className="input-wrapper">
            <FaLock className="input-icon" />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Ingresa tu contraseña"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              disabled={loading}
              style={{ paddingRight: '2.5rem' }}
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="password-toggle"
            >
              {showPassword ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
            </button>
          </div>
        </div>
      )}
      
      {/* Error message */}
      {errorMsg && (
        <div className="error-message">
          <FaLock />
          {errorMsg}
        </div>
      )}

      {/* Success message */}
      {successMsg && (
        <div className="success-message">
          <FaEnvelope />
          {successMsg}
        </div>
      )}
      
      {/* Forgot password link */}
      {!isForgotPassword && (
        <div className="forgot-password-link">
          <button
            type="button"
            onClick={toggleForgotPassword}
            className="text-link"
          >
            ¿Olvidaste tu contraseña?
          </button>
        </div>
      )}

      {/* Back to login link */}
      {isForgotPassword && (
        <div className="back-to-login-link">
          <button
            type="button"
            onClick={toggleForgotPassword}
            className="text-link"
          >
            ← Volver al login
          </button>
        </div>
      )}
      
      {/* Submit button */}
      <button type="submit" className="submit-button" disabled={loading}>
        {loading ? (
          <>
            <div className="loading-spinner"></div>
            {isForgotPassword ? 'Enviando...' : 'Iniciando sesión...'}
          </>
        ) : (
          <>
            {isForgotPassword ? <FaKey /> : <FaSignInAlt />}
            {isForgotPassword ? 'Enviar Instrucciones' : 'Iniciar Sesión'}
          </>
        )}
      </button>
    </form>
  )
}